import { Text, Tag } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { CellValue } from 'react-table';

import { IndeterminateCheckbox } from 'components/Table';
import { roles } from 'global/rolesAndPermissions';
import { routePaths } from 'global/routePaths';
import { getUserStore } from 'utils/helpers';

export const getJobsTasksCommonColumns = (t: any) => {
  const userStore = getUserStore();

  return [
    ...(userStore?.userInfo?.roleId === roles.ADMIN ||
    (userStore?.userInfo?.roleId === roles.MANAGER && userStore?.permissions?.manageTimesheets)
      ? [
          {
            id: 'selection',
            width: 30,
            Header: ({ getToggleAllRowsSelectedProps }: any) => {
              return (
                <IndeterminateCheckbox
                  {...getToggleAllRowsSelectedProps()}
                  colorScheme="secondary"
                  data-testid="select-all-checkbox"
                />
              );
            },
            Cell: ({ row }: any) => {
              return (
                <IndeterminateCheckbox
                  {...row.getToggleRowSelectedProps()}
                  colorScheme="secondary"
                  data-testid="select-checkbox"
                />
              );
            },
          },
        ]
      : []),
    {
      Header: t('jobsTasks:jobName'),
      accessor: 'name',
      width: 200,
      enableSort: true,
      Cell: (data: CellValue) => {
        return (
          <>
            <Text
              as={RouterLink}
              to={routePaths.jobsAndTasks.jobDetail.replace(':id', data.row.original?.id)}
              fontWeight="semibold"
              color="primary.500"
              mb="1"
            >
              {data.value}
            </Text>
            <Text>{data.row.original.location}</Text>
          </>
        );
      },
    },
    {
      Header: t('jobsTasks:assignedTo'),
      accessor: 'assigned_users',
      width: 200,
      Cell: (data: CellValue) => {
        return (
          <Tag fontWeight="semibold" color="primary.500">
            {Array.isArray(data.value) && data.value.length
              ? data.value.length === 1
                ? `${data.value[0]?.firstName} ${data.value[0]?.lastName}`
                : `${data.value[0]?.firstName} ${data.value[0]?.lastName} and ${data.value.length - 1} others`
              : t('common:all')}
          </Tag>
        );
      },
    },
    {
      Header: t('jobsTasks:trackMileage'),
      accessor: 'trackMileage',
      Cell: (data: CellValue) => {
        return data.value ? (
          <Text color="success.500" fontWeight="semibold">
            {t('common:yes')}
          </Text>
        ) : (
          <Text color="secondary.700" fontWeight="semibold">
            {t('common:no')}
          </Text>
        );
      },
    },
  ];
};
